module.exports = __webpack_public_path__ + "static/media/roundImg2.26596b0f.svg";